import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {User} from "../classes/user";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  user: BehaviorSubject<User> = new BehaviorSubject<User>(new User(null));
  user$: Observable<User> = this.user.asObservable();

  constructor() { }

  setUser(u: User): void {
    this.user.next(u);
  }

  getUser(): User {
    return this.user.getValue();
  }

  get getUserType(): string {
    return this.user?.getValue()?.user_role_name;
  }

  get getUserCityName(): string {
    return this.user?.getValue()?.user_city_name;
  }

  get getFullUserName(): string {
    return this.user?.getValue()?.user_name;
  }

  get getUserContact(): string {
    return this.user?.getValue()?.user_mobile_number;
  }

  get getUserId(): number {
    return this.user?.getValue()?.user_id;
  }

  get getUserRoleId(): number {
    return this.user?.getValue()?.user_role_id;
  }

  get getUserCityId(): number {
    return this.user?.getValue()?.user_city_id;
  }

  get getUserAccessToken(): string {
    return this.user?.getValue()?.user_access_token;
  }

  get getUserphoneUuid(): string {
    return this.user?.getValue()?.phone_uuid;
  }

}
